import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import type { CountryRegion } from '@recruitee/locations-types';

import { RegionsHttpClient } from './regions.types';

@Injectable()
export class TellentRegionsHttpClient extends RegionsHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetchRegions(countryCode: string): Observable<CountryRegion[]> {
    return this.httpApi.get(`/regions`, { country_code: countryCode }).pipe(map(data => data.data));
  }
}
